<!-- Spinner de tela cheia -->
<app-loading-spinner [active]="fullScreenLoading"></app-loading-spinner>

<div class="row no-gutters align-items-center flex-fill" [formGroup]="form">
    <div class="col-12 offset-lg-1 col-lg-10">

        <div class="row">
            <div class="col-12 col-lg-9" style="position: relative;">

                <span class="basic-content-title">
                    Declaração de Condição de Investidor
                </span>
                <app-spacer [bottom]="16"></app-spacer>
                <div class="d-flex align-items-center gap-2">
                    <span class="is-required mr-2"
                        *ngIf="form.controls.investor_condition.value === null">*</span>
                    <span class="basic-content-description">
                        Selecione uma das opções abaixo que melhor descreve sua
                        condição de investidor.
                    </span>
                </div>
                <app-spacer [bottom]="24"></app-spacer>
            </div>
        </div>

        <div class="row">
            <div class="col-12 col-lg-9">
                <app-select [items]="qualificationOptions" [group]="form"
                    controlName="qualification" placeholder="Selecione"
                    label="Qualificação">
                </app-select>
                <app-spacer [bottom]="24"></app-spacer>
            </div>
        </div>

        <div class="row">

            <div class="col-12" *ngFor="let option of options">
                <app-radio
                    [isChecked]="form.controls.investor_condition.value === option.value"
                    formControlName="investor_condition" [value]="option.value">
                    <div class="flex-1 d-flex flex-column">
                        <span class="app-radio-text">
                            {{option.label}}
                        </span>
                    </div>
                </app-radio>
                <app-spacer [bottom]="24"></app-spacer>
            </div>
        </div>

        <ng-container *ngIf="form.controls.investor_condition.value !== null">
            <div class="row ml-2">
                <div class="col-12">
                    <app-spacer [bottom]="48"></app-spacer>
                </div>

                <div class="col-12">
                    <span class="term-text" [innerHtml]="getText()"></span>

                    <app-spacer [bottom]="24"></app-spacer>
                </div>
            </div>

            <div class="row">

                <div class="col-12"
                    *ngIf="form.controls.investor_condition.value">
                    <div class="row">
                        <div class="col-2 d-flex justify-content-end align-items-start"
                            style="padding-top: 3px;">
                            <span class="is-required" style="position: static;"
                                *ngIf="!form.controls.signed.value">*</span>
                        </div>
                        <div class="col-10">
                            <app-radio [multiple]="true"
                                formControlName="signed">
                                <div class="flex-1 d-flex flex-column">
                                    <span class="term-option-title">
                                        Por ser expressão da verdade, assino a
                                        presente
                                    </span>
                                    <span class="term-option-description">
                                        Ao selecionar este item, você estará
                                        assinando
                                        este contrato
                                    </span>
                                </div>
                            </app-radio>
                        </div>
                    </div>
                    <app-spacer [bottom]="24"></app-spacer>
                </div>

            </div>
        </ng-container>

    </div>
</div>